import { render, staticRenderFns } from "./FilterDevice.vue?vue&type=template&id=0fe0a3ae&scoped=true"
import script from "./FilterDevice.vue?vue&type=script&lang=ts"
export * from "./FilterDevice.vue?vue&type=script&lang=ts"
import style0 from "./FilterDevice.vue?vue&type=style&index=0&id=0fe0a3ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe0a3ae",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/filter/filter-device.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Ffilter%2FFilterDevice.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports